import { identityCardType } from 'json/customer-options'
import { paymentStatesOfScan } from 'json/payment'
import { qrCodeBusinessTypes } from 'json/index'
export let tableLabels = [{
  label: '付款方姓名',
  value: 'paymentInfo.firstName'
},
{
  label: 'Vip',
  value: 'vipNumber'
},
{
  label: '付款金额',
  value: 'paymentDetails.amount_show'
},
{
  label: '支付的流水号',
  value: 'thirdNumber'
},
{
  label: '支付最后更新时间',
  value: 'lastModified_date',
  minWidth: 150
},
{
  label: '支付方式',
  value: 'paymentDetails.paymentChannel'
},
{
  label: '付款方手机号',
  value: 'paymentInfo.mobile'
},
{
  label: '付款方证件号',
  value: 'paymentInfo.identityCard'
},
{
  label: '付款方证件类型',
  value: 'paymentInfo.identity_card_type'
},
{
  label: '收款方公司名称',
  value: 'payeeInfo.companyName'
},
{
  label: '收款方业务员',
  value: 'payeeInfo.firstName'
},
{
  label: '收款方业务员手机',
  value: 'payeeInfo.mobile'
},
{
  label: '订单流水号',
  value: 'orderNumber'
},
{
  label: '支付发起时间',
  value: 'created_date',
  minWidth: 150
},
{
  label: '支付状态',
  value: 'status_show',
  minWidth: 120
},
{
  label: '业务类型',
  value: 'type_text'
}
]
export let tableLabelsOfLifeExperienceHall = [{
  label: '付款方姓名',
  value: 'paymentInfo.firstName'
},
{
  label: '付款金额',
  value: 'paymentDetails.amount_show'
},
{
  label: '支付的流水号',
  value: 'thirdNumber'
},
{
  label: '支付最后更新时间',
  value: 'lastModified_date',
  minWidth: 150
},
{
  label: '支付方式',
  value: 'paymentDetails.paymentChannel'
},
{
  label: '付款方手机号',
  value: 'paymentInfo.mobile'
},
{
  label: '收款方公司名称',
  value: 'payeeInfo.companyName'
},
{
  label: '收款方业务员',
  value: 'payeeInfo.firstName'
},
{
  label: '收款方业务员手机',
  value: 'payeeInfo.mobile'
},
{
  label: '订单流水号',
  value: 'orderNumber'
},
{
  label: '支付发起时间',
  value: 'created_date',
  minWidth: 150
},
{
  label: '支付状态',
  value: 'status_show',
  minWidth: 120
}]
export let filterLabels = [{
  label: '发起时间',
  type: 'time-slot',
  startName: 'payStartTime', // 返回数据时，开始时间的字段名
  endName: 'payEndTime', // 返回数据时，结束时间的字段名
  value: 'payTime'
},
{
  label: '支付完成时间',
  type: 'time-slot',
  startName: 'completedStartTime', // 返回数据时，开始时间的字段名
  endName: 'completedEndTime', // 返回数据时，结束时间的字段名
  value: 'completedTime',
  clearable: true
},
{
  label: '订单状态',
  type: 'select',
  value: 'status',
  options: paymentStatesOfScan,
  clearable: true
},
{
  label: '金额范围',
  clearable: true,
  type: 'price-slot',
  minName: 'amountStart',
  maxName: 'amountEnd',
  value: 'amout'
},
{
  label: '付款方证件类型',
  clearable: true,
  type: 'select',
  value: 'identityCardType',
  options: identityCardType
},
{
  label: '业务类型',
  clearable: true,
  type: 'select',
  value: 'type',
  options: qrCodeBusinessTypes
}
]

export let filterLabelsOfLifeExperienceHall = [{
  label: '发起时间',
  type: 'time-slot',
  startName: 'payStartTime', // 返回数据时，开始时间的字段名
  endName: 'payEndTime', // 返回数据时，结束时间的字段名
  value: 'payTime'
},
{
  label: '支付完成时间',
  type: 'time-slot',
  startName: 'completedStartTime', // 返回数据时，开始时间的字段名
  endName: 'completedEndTime', // 返回数据时，结束时间的字段名
  value: 'completedTime',
  clearable: true
},
{
  label: '订单状态',
  type: 'select',
  value: 'status',
  options: paymentStatesOfScan,
  clearable: true
},
{
  label: '金额范围',
  clearable: true,
  type: 'price-slot',
  minName: 'amountStart',
  maxName: 'amountEnd',
  value: 'amout'
}
]
export let filterLabelsOrg = {
  label: '分/子公司',
  type: 'select',
  value: 'organizationId',
  clearable: true,
  options: [],
  props: {
    label: 'fullName',
    value: 'id'
  }
}
